import { useQuery } from '@apollo/react-hooks';
import { useState, useEffect } from 'react';
import REPROCESS_CAMPAIGN_STATUS from '../../../../GraphQl/Queries/REPROCESS_CAMPAIGN_STATUS';
import REPROCESS_STATUS_SUBSCRIPTION from "../../../../GraphQl/Subscriptions/REPROCESS_STATUS_SUBSCRIPTION";

const ReprocessHandler = (id) => {
  const [reprocessStatus, setReprocessStatus] = useState();
  const [reprocessData, setReprocessData] = useState();
  const reprocessKey = `display-campaign-${id}`;
  const { data, subscribeToMore} = useQuery(REPROCESS_CAMPAIGN_STATUS, {
    variables: {
      key: reprocessKey,
    },
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (data) {
      if (data.reprocessStatus) {
        setReprocessStatus(data.reprocessStatus.status);
        setReprocessData(data.reprocessStatus);
      } else {
        // No reprocess history exists for this campaign
        setReprocessStatus(null);
        setReprocessData(null);
      }
    }
  }, [data]);

  subscribeToMore({
    document: REPROCESS_STATUS_SUBSCRIPTION,
    variables: {
      where: {
        node: {
          key: reprocessKey,
        },
      },
    },
    updateQuery: (prev, data) => {
      console.log(data);
      if (data.subscriptionData.data.reprocessStatus.node) {
        const { status } = data.subscriptionData.data.reprocessStatus.node;
        setReprocessStatus(status);
        setReprocessData(data.subscriptionData.data.reprocessStatus.node);
      }
    },
  });

  return {
    reprocessStatus,
    reprocessData,
  };
};

export default ReprocessHandler;
